"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAnalyticsCategory = exports.handleTargetingCategory = exports.onChange = exports.onFirstAction = exports.cookieGuiOptions = exports.getCookiePolicyContent = void 0;
require("vanilla-cookieconsent");
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_ga4_1 = __importDefault(require("react-ga4"));
var cookiePolicyCS_1 = require("./cookiePolicyCS");
var cookiePolicySK_1 = require("./cookiePolicySK");
var cookiePolicyHU_1 = require("./cookiePolicyHU");
var cookiePolicyPL_1 = require("./cookiePolicyPL");
var cookiePolicyDE_1 = require("./cookiePolicyDE");
var cookiePolicyIT_1 = require("./cookiePolicyIT");
var utils_1 = require("./utils");
var api_1 = require("./api");
var cookiePolicyEN_1 = require("./cookiePolicyEN");
var cookiePolicyES_1 = require("./cookiePolicyES");
var cookiePolicyPT_1 = require("./cookiePolicyPT");
var cookiePolicyFR_1 = require("./cookiePolicyFR");
var getCookiePolicyContent = function (lang) {
    switch (lang) {
        case 'cs': {
            return cookiePolicyCS_1.cookiesCs;
        }
        case 'de': {
            return cookiePolicyDE_1.cookiesDe;
        }
        case 'fr': {
            return cookiePolicyFR_1.cookiesFr;
        }
        case 'sk': {
            return cookiePolicySK_1.cookiesSk;
        }
        case 'hu': {
            return cookiePolicyHU_1.cookiesHu;
        }
        case 'pl': {
            return cookiePolicyPL_1.cookiesPl;
        }
        case 'es': {
            return cookiePolicyES_1.cookiesEs;
        }
        case 'it': {
            return cookiePolicyIT_1.cookiesIt;
        }
        case 'enUS':
        case 'en': {
            return cookiePolicyEN_1.cookiesEn;
        }
        case 'pt':
        case 'pt-BR': {
            return cookiePolicyPT_1.cookiesPt;
        }
        // FIXME english translation and others are missing for now
        default:
            throw TypeError('unsupported language');
    }
};
exports.getCookiePolicyContent = getCookiePolicyContent;
exports.cookieGuiOptions = {
    consent_modal: {
        layout: 'cloud',
        position: 'bottom center',
        transition: 'slide',
        swap_buttons: false, // enable to invert buttons
    },
    settings_modal: {
        layout: 'bar',
        // position: 'left',           // left/right
        transition: 'slide', // zoom/slide
    },
};
/**
 * This function will be executed only once, when the user takes the first action (accept/reject).
 *
 * parameters:
 *
 * user_preferences: contains the same data provided by the .getUserPreferences() API
 * cookie: contains the current value of the cookie
 * @param _user_preferences
 * @param cookie
 */
var onFirstAction = function (axiosClient, cookieConsent, _user_preferences, cookie) { return __awaiter(void 0, void 0, void 0, function () {
    var revision, cookieConsentData, _a, acceptType, acceptedCategories, rejectedCategories, generatedCookiesClientId, dataToBeStored, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                revision = cookie.revision;
                cookieConsentData = cookieConsent.get('data');
                _a = cookieConsent.getUserPreferences(), acceptType = _a.accept_type, acceptedCategories = _a.accepted_categories, rejectedCategories = _a.rejected_categories;
                generatedCookiesClientId = (0, utils_1.generateRandomAlphabeticalId)();
                dataToBeStored = __assign(__assign({}, cookieConsentData), { clientId: generatedCookiesClientId, date: new Date().toISOString(), type: 'firstAction', revision: revision, acceptType: acceptType, acceptedCategories: acceptedCategories, rejectedCategories: rejectedCategories });
                cookieConsent.set('data', {
                    value: dataToBeStored,
                });
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, api_1.storeClientCookies)(axiosClient, dataToBeStored)];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                err_1 = _b.sent();
                throw err_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.onFirstAction = onFirstAction;
/**
 * This function will be executed (only if consent has already been given):
 *
 * when user changes his preferences (accepts/rejects a cookie category)
 *
 * parameters:
 *
 * cookie: contains the current value of the cookie
 * changed_categories: array of categories whose state (accepted/rejected) just changed
 * @param cookie
 * @param changed_preferences
 */
var onChange = function (axiosClient, cookieConsent, cookie, changed_preferences) { return __awaiter(void 0, void 0, void 0, function () {
    var cookieConsentData, _a, acceptType, acceptedCategories, rejectedCategories, revision, dataToBeChange, err_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cookieConsentData = cookieConsent.get('data');
                _a = cookieConsent.getUserPreferences(), acceptType = _a.accept_type, acceptedCategories = _a.accepted_categories, rejectedCategories = _a.rejected_categories;
                revision = cookie.revision;
                dataToBeChange = __assign(__assign({}, cookieConsentData), { clientId: cookieConsentData.clientId, date: new Date().toISOString(), type: 'change', revision: revision, changedPreferences: changed_preferences, acceptType: acceptType, acceptedCategories: acceptedCategories, rejectedCategories: rejectedCategories });
                cookieConsent.set('data', {
                    value: dataToBeChange,
                });
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, api_1.storeClientCookies)(axiosClient, dataToBeChange)];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                err_2 = _b.sent();
                throw err_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.onChange = onChange;
var handleTargetingCategory = function (consent, reloadPossibly) {
    if (consent.allowedCategory('targeting')) {
        if (reloadPossibly) {
            // @ts-ignore
            window.location.reload();
        }
    }
    else {
        js_cookie_1.default.remove('1P_JAR');
        js_cookie_1.default.remove('NID');
        js_cookie_1.default.remove('OTZ');
        js_cookie_1.default.remove('DV');
    }
};
exports.handleTargetingCategory = handleTargetingCategory;
var handleAnalyticsCategory = function (googleAnalyticsUa, consent, reloadPossibly) {
    if (googleAnalyticsUa && consent.allowedCategory('analytics') && process.env.NODE_ENV === 'production') {
        react_ga4_1.default.initialize(googleAnalyticsUa);
        if (reloadPossibly) {
            // @ts-ignore
            window.location.reload();
        }
    }
    else {
        js_cookie_1.default.remove('_ga');
        js_cookie_1.default.remove('_gat');
        js_cookie_1.default.remove('_gid');
    }
};
exports.handleAnalyticsCategory = handleAnalyticsCategory;
